module.exports = __webpack_public_path__ + "img/lost.4799c96f.svg";